import React, {useContext} from "react";
import {Appointment, Page, PatientInfo} from "./types";
import {ActionContext, ActionType} from "../components/hooks/provider";
import {LangManager} from "../components/i18n/langManager";

interface IProps {
    patientInfo: PatientInfo,
    appointment: Appointment
    lastPage: Page
}

export default function VerifyFailed(props: IProps) {
    const {dispatchActionState, actionState} = useContext(ActionContext)
    const langManager = LangManager(actionState.language)
    const $title = (
        <p className={"text-black text-base font-medium leading-5"}>{`${langManager.onlineCheckin} ${props.patientInfo.name}`}</p>
    )

    const $description = (
        <div className={"w-full h-max bg-[#F3DADA] flex flex-col mt-3"}>
            <p className={"text-sm text-black leading-5"}>{langManager.verifyFailed1}
                {langManager.verifyFailed2} {<span className={"text-blue-500"}>{props.appointment.clinicPhone}</span>} {langManager.verifyFailed3}
            </p>
        </div>
    )

    const $buttons = (
        <div className={"w-full grid grid-cols-2 space-x-5 mt-6"}>
            <button onClick={() => {
                dispatchActionState({type: ActionType.page, value: props.lastPage})
            }} type={"button"} className={" py-3 px-2 text-primary font-medium bg-white border-2 border-primary rounded-xl"}>
                {langManager.back}
            </button>

            <button disabled={true} type={"button"} className={"py-3 px-2 text-white font-medium bg-[#B0B1B2] disabled rounded-xl"}>
                {langManager.continue}
            </button>
        </div>
    )
    return (
        <div className={"w-full"}>
            <div className={"w-full bg-white px-5 pt-4 pb-10"}>
                {$title}
                {$description}
                {$buttons}
            </div>
        </div>
    )
}
